export const PERKS_SLICE_NAME = "perks"
